// NeuralConnecting — the "RE-ROUTING NEURAL LINK…" overlay shown briefly over the
// chat pane while switching channels (cyberpunk only; renders nothing otherwise).
export default function NeuralConnecting({ name }) {
  const cyber = typeof document !== "undefined" && document.documentElement.dataset.theme === "cyberpunk";
  if (!cyber) return null;
  return (
    <div className="neural-connect" aria-hidden>
      <div className="neural-connect__scan" />
      <div className="neural-connect__spin" />
      <div className="neural-connect__title">RE-ROUTING NEURAL LINK…</div>
      {name ? <div className="neural-connect__sub">JACKING INTO {name}</div> : null}
    </div>
  );
}
